<template>
    <!-- Quantity popup, identical flow to the Catalogue / Actualités pages.
         Open it from a parent via: this.$refs.addToCartModal.open(item) -->
    <b-modal centered size="sm" ref="modal" :title="product.Description || 'Ajouter à la commande'" hide-footer>
        <b-form-input placeholder="La quantité demandée" ref="qteInput" v-model="requestedQte" type="number"
            :disabled="busy" @keyup.enter="handleOk" />
        <div class="d-block text-center">
            <b-button variant="relief-success" class="mt-1" :disabled="busy" @click="handleOk">
                <b-spinner v-if="busy" small class="mr-25" /> Valider
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
    name: 'AddToCartModal',
    data() {
        return {
            product: { Description: '' },
            requestedQte: '',
            busy: false,
        };
    },
    methods: {
        // Called by the parent: opens the popup for the given actualité item (must carry a `No`).
        open(item) {
            this.product = item || { Description: '' };
            this.requestedQte = '';
            this.$refs.modal.show();
            setTimeout(() => {
                if (this.$refs.qteInput) this.$refs.qteInput.focus();
            }, 400);
        },
        async handleOk() {
            if (this.busy) return;
            this.busy = true;
            this.$emit('busy', true);
            try {
                // Resolve the catalogue item code from the NAV item No, then add via the same
                // GET_INVENTORY action the catalogue uses (validates stock/price + saves the line).
                console.log('[AddToCartModal] No =', JSON.stringify(this.product && this.product.No));
                const resp = await this.$http.get('_item/getItemCodeByItemNo/' + this.product.No);
                console.log(resp);
                console.log('[AddToCartModal] resp.data =', JSON.stringify(resp.data),
                    '| auth =', resp.config && resp.config.headers && resp.config.headers.Authorization);
                if (resp.data !== '' && resp.data != null) {
                    // Hydrates the in-memory item store from IndexedDB if needed (e.g. landing on Accueil).
                    const itemToAdd = await this.$store.dispatch('app-items/GET_ITEM_BY_CODE_HYDRATED', resp.data);
                    console.log('[AddToCartModal] itemToAdd =', itemToAdd);
                    if (!itemToAdd) {
                        this.$refs.modal.hide();
                        this.$swal({
                            title: 'Article Actuellement Indisponible',
                            text: "Cet article n'existe pas dans le catalogue.",
                            icon: 'warning',
                            customClass: { confirmButton: 'btn btn-primary' },
                            buttonsStyling: false,
                        });
                        return;
                    }
                    itemToAdd['Qte'] = this.requestedQte;
                    try {
                        const response = await this.$store.dispatch('app-items/GET_INVENTORY', itemToAdd);
                        this.$toast.clear();
                        this.$toast({ component: ToastificationContent, props: response }, { timeout: 2000 });
                        this.$emit('added', itemToAdd);
                        this.$refs.modal.hide();
                    } catch (error) {
                        this.$toast.clear();
                        if (error && error.title == 'Article Actuellement Indisponible') {
                            this.$toast({ component: ToastificationContent, props: error }, { position: 'top-left' });
                        } else {
                            this.$toast({ component: ToastificationContent, props: error });
                        }
                    }
                } else {
                    this.$refs.modal.hide();
                    this.$swal({
                        title: 'Article Actuellement Indisponible',
                        text: "Cet article n'existe pas dans le catalogue.",
                        icon: 'warning',
                        customClass: { confirmButton: 'btn btn-primary' },
                        buttonsStyling: false,
                    });
                }
            } finally {
                this.busy = false;
                this.$emit('busy', false);
            }
        },
    },
};
</script>
